import { CartLinesUpdateEvent } from '@shopify/events';

/*
 * VÀLIEN — Cilt testi stil sayfası (10.09)
 *
 * Önceki sürümde her ekran kendi satır içi stillerini taşıyordu: bir rengi
 * değiştirmek kırk yere dokunmak demekti ve tasarım sisteminden kopuktu.
 * Artık tek bir yerdeyiz ve değerler valien-ds/src/tokens.css ile birebir.
 *
 * İki varyant, tek stil sayfası:
 *   .ctt--ritual     bordo alan, krem tipografi, simetrik, çerçeveli
 *   .ctt--editorial  kağıt krem, asimetrik, ince cetveller
 *
 * Ortak kurallar (ikisi de uyar): Playfair Display yalnız 400, gövde Jost,
 * köşe yarıçapı 0 (tek istisna ritüel varyantının mühür madalyonu ve şık
 * rozeti — bunlar yuvarlatılmış köşe değil, bilinçli daire biçimidir),
 * altın yok, palet yedi renkle kapalı.
 */
const STYLES = `
.ctt{
  --bordo:#4B0303; --koyu-bordo:#350202; --lacivert:#1B2340;
  --krem:#FDF6EC; --kagit:#FAF1E2; --mavi:#AFC9D6; --kahve:#2B1B12;
  --serif:'Playfair Display',Georgia,'Times New Roman',serif;
  --sans:'Jost','Helvetica Neue',Arial,sans-serif;
  --tr:.14em;
  --ink:var(--kahve); --ink-2:rgba(43,27,18,.68); --ink-3:rgba(43,27,18,.64);
  --line:rgba(75,3,3,.18); --line-2:rgba(75,3,3,.30);
  --zemin:var(--kagit); --vurgu:var(--bordo);
  display:block; font-family:var(--sans); color:var(--ink);
  -webkit-font-smoothing:antialiased;
}
.ctt *{box-sizing:border-box}
/*
 * iOS ve Android dokunulan öğeyi kendi gri rengiyle parlatıyor
 * (varsayılan rgba(0,0,0,.18)). Marka rengine çeviriyoruz.
 */
.ctt,.ctt button,.ctt a,.ctt label{-webkit-tap-highlight-color:transparent}
.ctt button{font-family:inherit;border-radius:0;cursor:pointer}
.ctt button:focus-visible{outline:1px solid var(--vurgu);outline-offset:2px}
.ctt a{color:var(--vurgu);text-decoration:none}
.ctt a:hover .ctt-step__name{text-decoration:underline}

.ctt-screen{min-height:78vh;background:var(--zemin);display:flex;align-items:center;justify-content:center;padding:72px 24px}

/* — tipografi — */
.ctt-display{font-family:var(--serif);font-weight:400;font-size:clamp(30px,4.4vw,54px);line-height:1.16;margin:0;color:var(--ink);text-wrap:pretty}
.ctt-display--m{font-size:clamp(23px,3.2vw,34px);line-height:1.3}
.ctt-lede{font-size:15px;font-weight:300;line-height:1.85;color:var(--ink-2);margin:0;max-width:52ch;text-wrap:pretty}
.ctt-fine{font-size:11px;font-weight:300;line-height:1.7;color:var(--ink-3);margin:0;max-width:56ch}
.ctt-eyebrow{display:flex;align-items:center;gap:12px;font-size:10.5px;font-weight:500;letter-spacing:var(--tr);color:var(--ink-2)}
.ctt-tick{display:block;width:24px;height:1px;background:var(--line-2);flex:none}
.ctt-logo{display:block;height:auto}
.a-head,.ctt-quiz__rail{display:contents}

/* — butonlar — */
.ctt-btn{background:var(--vurgu);color:var(--krem);border:1px solid var(--vurgu);padding:20px 52px;font-size:11.5px;font-weight:500;letter-spacing:.24em;transition:opacity .18s ease}
.ctt-btn:hover{opacity:.88}
.ctt-btn--wide{width:100%;margin-top:18px}
.ctt-btn--ghost{background:none;color:var(--vurgu);border:1px solid var(--line-2);padding:15px 24px;letter-spacing:.2em;font-size:10.5px;width:100%}
.ctt-btn--ghost:hover{background:rgba(75,3,3,.05);opacity:1}
.ctt-btn:disabled{opacity:.7;cursor:default}
.ctt-link{background:none;border:none;padding:4px 0;font-size:10.5px;letter-spacing:.2em;color:var(--ink-3)}
.ctt-link:hover{color:var(--ink)}
.ctt-link--center{align-self:center}

/* — künye listesi — */
.ctt-spec{list-style:none;margin:0;padding:0}
.ctt-spec__row{display:flex;align-items:baseline;justify-content:space-between;gap:24px;padding:15px 0;border-top:1px solid var(--line)}
.ctt-spec__row:last-child{border-bottom:1px solid var(--line)}
.ctt-spec__label{font-size:12.5px;font-weight:300;color:var(--ink-2)}
.ctt-spec__value{font-family:var(--serif);font-size:19px;color:var(--vurgu)}

/* — giriş — */
.ctt-intro{width:100%;max-width:1180px}

/* — sorular — */
.ctt-quiz{width:100%;max-width:820px}
.ctt-quiz__head{display:flex;align-items:baseline;gap:16px;font-size:10.5px;letter-spacing:var(--tr);color:var(--ink-3)}
.ctt-quiz__num{font-family:var(--serif);font-size:22px;letter-spacing:0;color:var(--vurgu);min-width:52px}
.ctt-quiz__cat{flex:1}
.ctt-progress{position:relative;height:1px;background:var(--line);margin-top:14px}
.ctt-progress i{position:absolute;left:0;top:0;height:1px;background:var(--vurgu);transition:width .5s ease}
.ctt-quiz .ctt-display{margin-top:44px;max-width:19ch}
.ctt-options{display:flex;flex-direction:column;gap:0;margin-top:40px}
.ctt-option{display:flex;align-items:center;gap:20px;text-align:left;width:100%;padding:20px 4px;background:none;border:none;border-top:1px solid var(--line);transition:background .18s ease,padding .18s ease}
.ctt-option:last-child{border-bottom:1px solid var(--line)}
.ctt-option__key{font-family:var(--serif);font-size:15px;color:var(--ink-3);flex:none;width:28px;text-align:center;transition:color .18s ease}
.ctt-option__text{font-size:14.5px;font-weight:300;line-height:1.5;color:var(--ink)}
.ctt-option:hover{background:rgba(75,3,3,.035);padding-left:12px}
/*
 * Basılı ve seçili hâl tam bordo. Yarı saydam dolgu tarayıcının kendi
 * dokunma parlamasıyla karışıp soluk pembe görünüyordu; parlama kapatıldı.
 */
.ctt-option:active,
.ctt-option.is-on{background:var(--bordo);border-color:var(--bordo)}
.ctt-option:active .ctt-option__text,
.ctt-option.is-on .ctt-option__text{color:var(--krem)}
.ctt-option:active .ctt-option__key,
.ctt-option.is-on .ctt-option__key{color:var(--krem);border-color:rgba(253,246,236,.55)}
.ctt-quiz__foot{display:flex;justify-content:space-between;align-items:center;margin-top:32px;font-size:10.5px;letter-spacing:.2em;color:var(--ink-3)}

/* — yükleniyor: spinner değil, çizilen bir cetvel — */
.ctt-screen--loading.has-gorsel{position:relative;overflow:hidden;padding:0;background:var(--bordo)}
.ctt-loading__gorsel{position:absolute;inset:0;display:block}
.ctt-loading__gorsel img{width:100%;height:100%;object-fit:cover;object-position:center;display:block}
.ctt-screen--loading.has-gorsel::before{display:none}
/*
 * Alt kenarda koyu bir geçiş: cetvel ve satır kadifenin üstünde okunmuyordu.
 */
.ctt-screen--loading.has-gorsel::after{
  content:'';position:absolute;left:0;right:0;bottom:0;height:200px;pointer-events:none;
  background:linear-gradient(to top,rgba(31,10,10,.80),rgba(31,10,10,0))
}
.ctt-screen--loading.has-gorsel .ctt-loading{position:relative;z-index:1;align-self:flex-end;padding-bottom:40px;gap:20px}
.ctt-screen--loading.has-gorsel .ctt-loading__text{color:rgba(253,246,236,.86);font-weight:400}
.ctt-screen--loading.has-gorsel .ctt-draw{background:rgba(253,246,236,.30)}
.ctt-screen--loading.has-gorsel .ctt-draw i{background:var(--krem)}
.ctt-loading{display:flex;flex-direction:column;align-items:center;gap:32px}
.ctt-loading__logo{width:150px}
.ctt-screen--loading.has-gorsel .ctt-loading__logo{width:132px;opacity:.95}
.ctt-draw{width:min(280px,60vw);height:1px;background:var(--line)}
.ctt-draw i{display:block;height:1px;background:var(--vurgu);width:0;animation:ctt-draw 1.7s cubic-bezier(.4,0,.2,1) forwards}
@keyframes ctt-draw{to{width:100%}}
.ctt-loading__text{font-size:11px;letter-spacing:var(--tr);color:var(--ink-3);margin:0}

/* — iletişim kartı — */
.ctt-card{width:100%;max-width:560px;display:flex;flex-direction:column;gap:22px;background:rgba(253,246,236,.6);border:1px solid var(--line);padding:clamp(32px,5vw,56px)}
.ctt-formslot{margin-top:6px}

/* — sonuç — */
.ctt-result{width:100%;max-width:1180px;display:grid;grid-template-columns:340px 1fr;gap:clamp(40px,5vw,80px);align-items:start}
.ctt-col-side{display:flex;flex-direction:column;align-items:stretch;gap:22px;position:sticky;top:32px}
.ctt-col-main{display:flex;flex-direction:column;gap:28px;min-width:0}
.ctt-result__head{display:flex;flex-direction:column;gap:18px}
/*
 * Kampanya görselleri kendi metinlerini taşıyor, o yüzden kırpmıyoruz.
 * Doğal oranda bırakınca kare görsel sonucu eziyordu; yüksekliği sınırlıyoruz.
 */
/* Figür görsel kadar geniş olsun; sütunda gerilirse yazı görselin dışına düşüyor. */
.ctt-gorsel{margin:0;position:relative;display:block;width:fit-content;max-width:100%;align-self:flex-start}
.ctt-gorsel img{max-height:440px;width:auto;max-width:100%;height:auto;display:block}
.ctt-traits{display:flex;flex-wrap:wrap;gap:8px;margin-top:4px}
.ctt-trait{border:1px solid var(--line-2);padding:8px 16px;font-size:11px;font-weight:300;color:var(--ink-2)}

.ctt-verdict{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;
  gap:8px;text-align:center;padding:24px;
  background:radial-gradient(ellipse 60% 50% at 50% 50%,rgba(31,10,10,.55),rgba(31,10,10,0) 100%)}
.ctt-verdict__label{font-size:10px;letter-spacing:var(--tr);color:rgba(253,246,236,.82)}
.ctt-verdict__value{font-family:var(--serif);font-size:clamp(46px,7vw,72px);line-height:1;color:var(--krem);
  text-shadow:0 2px 24px rgba(31,10,10,.55)}
.ctt-verdict__sub{font-size:10.5px;letter-spacing:.2em;color:rgba(253,246,236,.82);border-top:1px solid rgba(253,246,236,.45);padding-top:8px}
.ctt-gorsel--bos{aspect-ratio:1;background:var(--bordo);max-width:440px}

.ctt-axes{display:grid;grid-template-columns:1fr 1fr;gap:32px}
.ctt-axis{display:flex;flex-direction:column;gap:10px;padding-top:16px;border-top:1px solid var(--line-2)}
.ctt-axis__label{font-size:9.5px;letter-spacing:var(--tr);color:var(--ink-3)}
.ctt-axis__value{font-family:var(--serif);font-size:21px;color:var(--vurgu);line-height:1.2}
.ctt-scale{display:flex;gap:5px;margin-top:2px}
.ctt-scale i{display:block;height:3px;flex:1;background:var(--line)}
.ctt-scale i.is-on{background:var(--vurgu)}
.ctt-note{font-size:13px;font-weight:300;line-height:1.8;color:var(--ink-2);margin:0;max-width:56ch}
.ctt-advice{margin:0;max-width:56ch;padding-top:16px;border-top:1px solid var(--vurgu)}
.ctt-advice__label{display:block;font-size:9.5px;letter-spacing:var(--tr);color:var(--ink-3);margin-bottom:10px}
.ctt-advice p{font-size:13px;font-weight:300;line-height:1.8;color:var(--ink-2);margin:0}

/* Sekmeler: iki kare buton, seçili olan tam bordo. Alt çizgili hâli fark edilmiyordu. */
/* Sola yaslı ve içeriği kadar geniş; tam genişlikte iki kocaman buton
   ürün listesinin başında gereksiz yer kaplıyordu. */
.ctt-tabs{display:inline-flex;width:fit-content;gap:0;border:1px solid var(--vurgu)}
.ctt-tab{flex:none;background:none;border:none;padding:9px 22px;font-size:11px;font-weight:500;letter-spacing:.16em;text-transform:uppercase;color:var(--vurgu);transition:background .18s ease,color .18s ease}
.ctt-tab+.ctt-tab{border-left:1px solid var(--vurgu)}
.ctt-tab.is-on{background:var(--vurgu);color:var(--krem)}

.ctt-steps{list-style:none;margin:14px 0 0;padding:0}
.ctt-step{display:flex;align-items:flex-start;gap:14px;padding:12px 0;border-bottom:1px solid var(--line)}
.ctt-step__no{font-family:var(--serif);font-size:15px;color:var(--ink-3);flex:none;width:18px;padding-top:2px}
.ctt-step__body{flex:1;min-width:0}
.ctt-step__label{display:block;font-size:9.5px;letter-spacing:var(--tr);color:var(--ink-3);margin-bottom:5px}
.ctt-step__link{display:flex;align-items:center;gap:16px;min-width:0}
.ctt-step__img{width:56px;height:56px;flex:none;object-fit:cover}
.ctt-step__meta{min-width:0}
.ctt-step__name{display:block;font-size:13.5px;font-weight:400;color:var(--ink);line-height:1.3}
.ctt-step__price{display:block;font-family:var(--serif);font-size:14px;color:var(--vurgu);margin-top:2px}
.ctt-step__why{font-size:12px;font-weight:300;line-height:1.5;color:var(--ink-3);margin:5px 0 0}
.ctt-add{align-self:center;flex:none;background:none;color:var(--vurgu);border:1px solid var(--line-2);padding:12px 16px;font-size:9.5px;letter-spacing:.14em;white-space:nowrap;transition:background .18s ease}
.ctt-add:hover{background:rgba(75,3,3,.05)}
.ctt-add.is-done{background:var(--lacivert);border-color:var(--lacivert);color:var(--krem)}
.ctt-weekly{margin-top:16px;padding-top:14px;border-top:1px solid var(--line-2)}
.ctt-weekly__title{font-size:9.5px;letter-spacing:var(--tr);color:var(--ink-3)}

/* Dikeyde sıkı: mobilde çok yer kaplıyordu. Yatay dolgu aynı kaldı. */
.ctt-coupon{display:flex;flex-direction:column;gap:6px;padding:14px 20px;
  background:var(--bordo);border:1px solid var(--bordo)}
.ctt-coupon__label{font-size:9.5px;letter-spacing:var(--tr);color:rgba(253,246,236,.66)}
.ctt-coupon__row{display:flex;align-items:center;justify-content:space-between;gap:12px}
.ctt-coupon__code{font-family:var(--serif);font-size:24px;line-height:1.1;letter-spacing:.06em;color:var(--krem)}
.ctt-copy{background:none;border:1px solid rgba(253,246,236,.42);padding:6px 12px;
  font-size:9px;letter-spacing:.14em;color:var(--krem);transition:background .18s ease}
.ctt-copy:hover{background:rgba(253,246,236,.12)}
.ctt-coupon__note{font-size:11px;font-weight:300;line-height:1.5;color:rgba(253,246,236,.66)}
.ctt-restart{align-self:flex-start}

/* ====================================================================== */
/* A · RİTÜEL — bordo alan, simetrik, çerçeveli                            */
/* ====================================================================== */
.ctt--ritual .ctt-screen--intro,
.ctt--ritual .ctt-screen--loading{
  --zemin:var(--bordo); --ink:var(--krem); --ink-2:rgba(253,246,236,.64);
  --ink-3:rgba(253,246,236,.58); --line:rgba(253,246,236,.18);
  --line-2:rgba(253,246,236,.30); --vurgu:var(--krem);
  position:relative
}
.ctt--ritual .ctt-screen--intro::before,
.ctt--ritual .ctt-screen--loading::before{
  content:'';position:absolute;inset:32px;border:1px solid rgba(253,246,236,.20);pointer-events:none
}
.ctt--ritual .ctt-intro{
  max-width:640px;display:flex;flex-direction:column;align-items:center;
  gap:36px;text-align:center
}
.ctt--ritual .ctt-intro .ctt-lede{max-width:46ch}
.ctt--ritual .ctt-intro .ctt-eyebrow{flex-direction:column;gap:18px}
.ctt--ritual .ctt-logo.a-logo{width:264px}
.ctt--ritual .a-spec{display:flex;gap:0;border:none}
.ctt--ritual .ctt-spec__row{flex-direction:column;align-items:center;gap:10px;padding:0 38px;border:none}
.ctt--ritual .ctt-spec__row+.ctt-spec__row{border-left:1px solid rgba(253,246,236,.20)}
.ctt--ritual .ctt-spec__label{order:2;font-size:9.5px;letter-spacing:var(--tr);text-transform:uppercase}
.ctt--ritual .ctt-spec__value{order:1;font-size:25px;color:var(--krem)}
.ctt--ritual .ctt-screen--intro .ctt-btn{background:var(--krem);color:var(--bordo);border-color:var(--krem);padding:21px 62px}
.ctt--ritual .ctt-loading__text{letter-spacing:.2em}

/* Soru, iletişim ve sonuç ekranları kağıt krem — koyu girişten sonra nefes */
.ctt--ritual .ctt-quiz,
.ctt--ritual .ctt-card{margin-inline:auto}
.ctt--ritual .ctt-quiz__head{justify-content:center;text-align:center}
.ctt--ritual .ctt-quiz .ctt-display{margin-inline:auto;text-align:center;max-width:22ch}
.ctt--ritual .ctt-option{border:1px solid var(--line);padding:20px 22px;margin-bottom:12px}
.ctt--ritual .ctt-option:last-child{margin-bottom:0}
.ctt--ritual .ctt-option:hover{padding-left:22px;border-color:var(--line-2)}
.ctt--ritual .ctt-option__key{width:34px;height:34px;border:1px solid var(--line-2);border-radius:50%;display:flex;align-items:center;justify-content:center}
.ctt--ritual .ctt-restart{align-self:center}

/* ====================================================================== */
/* B · EDİTORYAL — kağıt, asimetrik, cetvelli                              */
/* ====================================================================== */
.ctt--editorial .ctt-screen{padding-inline:clamp(24px,6vw,96px)}
.ctt--editorial .ctt-intro{
  display:grid;
  grid-template-columns:316px 1fr;
  grid-template-areas:"head head" "spec title" "spec lede" "spec cta" "fine fine";
  column-gap:clamp(40px,6vw,96px); row-gap:28px; align-items:start
}
.ctt--editorial .a-head{grid-area:head;display:flex;align-items:flex-end;justify-content:space-between;gap:24px;padding-bottom:22px;border-bottom:1px solid var(--line-2)}
.ctt--editorial .a-logo{width:186px}
.ctt--editorial .a-title{grid-area:title;font-size:clamp(34px,5.2vw,64px)}
.ctt--editorial .a-lede{grid-area:lede;font-size:16px}
.ctt--editorial .a-spec{grid-area:spec;grid-row:2/5}
.ctt--editorial .a-cta{grid-area:cta;justify-self:start}
.ctt--editorial .a-fine{grid-area:fine;padding-top:22px;border-top:1px solid var(--line-2);max-width:none}

.ctt--editorial .ctt-quiz{max-width:1180px;display:grid;grid-template-columns:316px 1fr;column-gap:clamp(40px,6vw,96px);row-gap:0;align-items:start}
.ctt--editorial .ctt-quiz__rail{display:flex;flex-direction:column;gap:26px;grid-column:1;grid-row:1}
.ctt--editorial .ctt-quiz__head{flex-direction:column;align-items:flex-start;gap:14px}
.ctt--editorial .ctt-quiz__num{font-size:56px;line-height:1;min-width:0}
.ctt--editorial .ctt-progress{margin-top:0}
.ctt--editorial .ctt-quiz .ctt-display{grid-column:2;grid-row:1;margin-top:0;max-width:none;font-size:clamp(26px,3.4vw,40px)}
.ctt--editorial .ctt-options{grid-column:2;margin-top:36px}
.ctt--editorial .ctt-quiz__foot{grid-column:2}

.ctt--editorial .ctt-card{background:none;border:none;border-top:1px solid var(--vurgu);border-bottom:1px solid var(--line-2);padding-inline:0}

/* — mobil — */
@media (max-width:899px){
  .ctt-screen{padding:44px 20px;min-height:0}
  /*
   * Yükleme ekranı mobilde tam ekran. --ctt-offset, bölümün sayfa başlığı
   * altında başladığı yüksekliktir; JS ölçüp yazıyor. Çıkarmazsak toplam
   * yükseklik başlık kadar taşıyor ve alt kenar tarayıcı çubuğunun altında
   * kalıyordu.
   */
  .ctt-screen--loading{
    min-height:calc(100vh - var(--ctt-offset, 0px));
    min-height:calc(100svh - var(--ctt-offset, 0px));
    padding-block:24px;
  }
  /*
   * Dikey görselde metin üstte. Ortadan kırpınca ilk satır ("RİTÜEL")
   * kesiliyordu; üstten hizalayıp alttan kırpıyoruz.
   */
  .ctt-loading__gorsel img{object-position:center top}
  /*
   * Sonuç ekranı mobilde iki kolon değil tek akış: rozet → cilt tipi anlatımı
   * → kupon → eksenler → rutin. Kupon önceden yan kolonun tamamıyla birlikte
   * en alta düşüyordu, rutinin de altında kalıyordu.
   */
  .ctt-result{display:flex;flex-direction:column;gap:22px}
  .ctt-col-main,.ctt-col-side{display:contents}
  .ctt-col-side{position:static}
  .ctt-gorsel{order:1;align-self:center}
  .ctt-result__head{order:2}
  .ctt-axes{order:3}
  .ctt-advice{order:4}
  .ctt-coupon{order:5}
  .ctt-routine{order:6}
  .ctt-btn--ghost{order:7}
  .ctt-col-side>.ctt-fine{order:8;text-align:center;margin-inline:auto}
  .ctt-restart{order:9;align-self:center}
  .ctt-axes{grid-template-columns:1fr 1fr;gap:16px}
  .ctt-axis__value{font-size:17px}
  .ctt-axis__label{font-size:9px}
  .ctt-step__img{width:52px;height:52px}
  .ctt-gorsel img{max-height:360px}
  .ctt--ritual .ctt-intro{gap:26px}
  .ctt--ritual .ctt-logo.a-logo{width:180px}
  .ctt--ritual .ctt-spec__row{padding:0 18px}
  .ctt--ritual .ctt-spec__value{font-size:21px}
  .ctt--ritual .ctt-btn{width:100%}
  .ctt--editorial .ctt-intro,
  .ctt--editorial .ctt-quiz{grid-template-columns:1fr;grid-template-areas:"logo" "eyebrow" "title" "lede" "spec" "cta" "fine"}
  .ctt--editorial .a-spec{grid-row:auto}
  .ctt--editorial .a-eyebrow{justify-content:flex-start;border:none;padding-bottom:0}
  .ctt--editorial .a-cta .ctt-btn,
  .ctt--editorial .ctt-btn{width:100%}
  .ctt--editorial .ctt-quiz__rail,
  .ctt--editorial .ctt-quiz .ctt-display,
  .ctt--editorial .ctt-options,
  .ctt--editorial .ctt-quiz__foot{grid-column:1}
  .ctt--editorial .ctt-quiz .ctt-display{grid-row:auto;margin-top:28px}
  .ctt--editorial .ctt-quiz__num{font-size:38px}
}
@media (prefers-reduced-motion:reduce){
  .ctt *{transition:none!important}
  .ctt-draw i{animation:none;width:100%}
}
`;



function cttSectionIds() {
  const ids = [];
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
  });
  return ids;
}

function cttDeferred() {
  if (CartLinesUpdateEvent.createPromise) return CartLinesUpdateEvent.createPromise();
  let resolve;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
}

function cttAddLines(lines, source) {
  const sectionIds = cttSectionIds();
  const deferred = cttDeferred();
  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: source,
      lines: lines.map((l) => ({ merchandiseId: l.id, quantity: l.quantity })),
      promise: deferred.promise,
    })
  );
  const body =
    lines.length === 1
      ? { id: lines[0].id, quantity: lines[0].quantity, sections: sectionIds.join(',') }
      : { items: lines, sections: sectionIds.join(',') };
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  })
    .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
    .then(({ ok, data }) => {
      if (!ok || data.status) throw new Error((data && data.message) || 'Sepete eklenemedi');
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then((r) => r.json())
        .then((cart) => {
          deferred.resolve({
            cart: CartLinesUpdateEvent.createCartFromAjaxResponse
              ? CartLinesUpdateEvent.createCartFromAjaxResponse(cart)
              : cart,
            detail: {
              items: cart.items,
              source,
              sourceId: source,
              itemCount: lines.length,
              sections: data.sections,
              didError: false,
            },
          });
          return cart;
        });
    })
    .catch((err) => {
      deferred.reject(new Error('add-to-cart-failed'));
      throw err;
    });
}

/**
 * VÀLIEN: Test sonucunda gösterilen indirim kodunu sepete otomatik uygular.
 * @param {string} code
 */
function cttApplyDiscountToCart(code) {
  return fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((cart) => {
      const existingCodes = (cart.discount_codes || [])
        .map((d) => d && d.code)
        .filter((c) => c && c.toLowerCase() !== code.toLowerCase());

      const alreadyApplied = (cart.discount_codes || []).some(
        (d) => d && d.code && d.code.toLowerCase() === code.toLowerCase()
      );
      if (alreadyApplied) return cart;

      const allCodes = [...existingCodes, code].join(',');

      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: allCodes }),
      }).then((res) => res.json());
    })
    .catch(() => {
      /* Sessizce yut: otomatik uygulama başarısız olsa bile müşteri kodu elle girebilir. */
    });
}

const QUESTIONS = [
  {
    cat: 'Cilt Yapısı',
    q: 'Sabah yüzünüzü yıkadıktan sonra hiçbir ürün sürmezseniz cildiniz nasıl hisseder?',
    a: ['Gergin ve kuru, hemen nem ister', 'Kısa sürede yağlanmaya başlar', 'Alnım parlar, yanaklarım kurur', 'Rahat ve dengeli kalır'],
  },
  {
    cat: 'Cilt Yapısı',
    q: 'Öğleden sonra cildinizin T-bölgesi (alın, burun, çene) nasıl görünür?',
    a: ['Mat kalır, gerginlik hissedebilirim', 'Belirgin şekilde parlar ve yağlanır', 'T-bölgesi parlar, yanaklarım normal veya kuru kalır', 'Dengeli kalır, belirgin bir değişiklik olmaz'],
  },
  {
    cat: 'Gözenek',
    q: 'Gözenekleriniz gün içinde ne kadar belirgin?',
    a: ['Neredeyse hiç görünmez', 'Burun ve yanaklarda oldukça belirgin', 'Sadece T-bölgesinde belirgin', 'Yakından bakınca hafifçe fark edilir'],
  },
  {
    cat: 'Hassasiyet',
    q: 'Yeni bir ürün denediğinizde cildiniz nasıl tepki verir?',
    a: ['Sık sık kızarır ve kaşınır', 'Nadiren, genelde sivilce çıkar', 'Bölgeye göre değişir', 'Genellikle sorunsuz kabul eder'],
  },
  {
    cat: 'Nem Dengesi',
    q: 'Kış aylarında cildinizde en çok neyi fark edersiniz?',
    a: ['Pul pul dökülme ve kuruluk', 'Yağlanma azalır ama devam eder', 'Yanaklar kurur, T-bölgesi aynı kalır', 'Belirgin bir değişim olmaz'],
  },
  {
    cat: 'Görünüm',
    q: 'Cildinizin genel tonu ve dokusu için ne söylersiniz?',
    a: ['Mat ve yer yer donuk', 'Parlak ve kalın dokulu', 'İki farklı bölge gibi davranıyor', 'Eşit ve pürüzsüz'],
  },
  {
    cat: 'Öncelik',
    q: 'Bir rutinden en çok ne beklersiniz?',
    a: ['Yoğun nem ve bariyer onarımı', 'Yağ dengesi ve gözenek kontrolü', 'Bölgesel denge ve hafiflik', 'Koruma ve mevcut dengeyi sürdürme'],
  },
  {
    cat: 'Hedef',
    q: 'Cildinizde en çok neyi değiştirmek istersiniz?',
    a: ['Sivilce ve kızarıklık görünümü', 'Leke ve ton eşitsizliği', 'Gözenek görünümü', 'Yaşlanma belirtilerinin görünümü'],
  },
  {
    /*
     * VÀLIEN (10.09): Yaş aralığı sorusu. Cilt TİPİ puanlamasına girmez —
     * yaş cilt tipini belirlemez. Yalnızca sonuç metnini ve rutin vurgusunu
     * kişiselleştirmek için kullanılır.
     */
    cat: 'Yaş Aralığı',
    q: 'Hangi yaş aralığındasınız?',
    a: ['18–24', '25–34', '35–44', '45 ve üzeri'],
  },
];

const SKIN_KEYS = ['kuru', 'yagli', 'karma', 'normal'];
const ROMAN = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
const CTT_COUPON_CODE = 'CILT125';

/*
 * Sonucu paylaşılabilir kılan URL parametresi.
 *
 * KVKK notu (12.09.2026): Bu parametre eskiden dokuz ham cevabı taşıyordu
 * (?ct=012301230). Cevapların bir kısmı klinik çağrışımlıdır ("sık sık kızarır
 * ve kaşınır", "sivilce ve kızarıklık görünümü"); bağlantı paylaşıldığında bu
 * yanıtlar sunucu loglarına ve sayfadaki her üçüncü taraf script'ine geçiyordu.
 * Özel Nitelikli Kişisel Veriler Rehberi'nin sağlık verisi tanımı bu eşiği
 * düşük tutuyor.
 *
 * Artık yalnızca TÜRETİLMİŞ sonuç taşınıyor: cilt tipi, hassasiyet bandı,
 * öncelik ve yaş aralığı — dört karakter. Ham yanıtlar cihazdan çıkmıyor.
 * Paylaşılan bağlantı aynı sonucu gösterir; testin kendisi değişmez.
 */
const CTT_URL_PARAM = 'ct';

/* Türetilmiş sonuç bandı — URL'de indeks olarak kodlanır. */
const CTT_SENS_KEYS = ['yok', 'egilim', 'belirgin'];

/*
 * VÀLIEN — Puanlama tablosu (Kademe 2, 06.09)
 *
 * Önceki motor cevabın ANLAMINI değil, seçilen şıkkın SIRASINI sayıyordu.
 * Şıklar 1-7. sorularda zaten A=kuru / B=yağlı / C=karma / D=normal düzeninde
 * sıralandığı için konvansiyonla çalışıyordu, ama üç gizli arızası vardı:
 *
 *   1) 8. soru ("kaç adımlı rutin uyguluyorsunuz?") cilt tipi sinyali taşımıyordu
 *      ama puanlanıyordu: "5+ adım, katmanlı" diyen kişi karma cilde oy vermiş
 *      oluyordu. O soru artık "öncelik" sorusu ve puanlamaya girmiyor (null).
 *   2) Tüm sorular eşit ağırlıktaydı. Artık cilt yapısını doğrudan ölçen
 *      sorular 2, dolaylı sinyaller 1 puan veriyor.
 *   3) Eşitlikte sonuç sistematik olarak "kuru"ya düşüyordu (sayacın 0. indeksi).
 *      Kademe 3'te tamamen çözüldü — bkz. computeResultKey().
 *
 * null = o soru cilt tipi puanlamasına girmez.
 */
const SCORING = [
  [{ kuru: 2 }, { yagli: 2 }, { karma: 2 }, { normal: 2 }],
  [{ kuru: 2 }, { yagli: 2 }, { karma: 2 }, { normal: 2 }],
  [{ kuru: 1 }, { yagli: 1 }, { karma: 1 }, { normal: 1 }],
  [{ kuru: 1 }, { yagli: 1 }, { karma: 1 }, { normal: 1 }],
  [{ kuru: 2 }, { yagli: 2 }, { karma: 2 }, { normal: 2 }],
  [{ kuru: 2 }, { yagli: 2 }, { karma: 2 }, { normal: 2 }],
  [{ kuru: 1 }, { yagli: 1 }, { karma: 1 }, { normal: 1 }],
  null,
  null,
];

/*
 * VÀLIEN — Doğrudan ölçüm soruları (10.09)
 * Ağırlığı 2 olan sorular cilt yapısını doğrudan ölçer; beraberlik çözümünde
 * ikinci kademe olarak yalnızca bunlar yeniden puanlanır. SCORING'den türetilir,
 * elle güncellenmez.
 */
const DIRECT_QUESTIONS = SCORING.reduce((acc, row, i) => {
  if (row && row.some((w) => w && Object.keys(w).some((k) => w[k] >= 2))) acc.push(i);
  return acc;
}, []);

/*
 * VÀLIEN — Hassasiyet ekseni (Kademe 3, 10.09)
 *
 * Önceden hassasiyet tek bir şıkka bağlı ikili bir bayraktı: 4. sorunun A şıkkı
 * işaretliyse "hassas", değilse değil. Bu, hassasiyeti cilt tipinin bir yan
 * etiketi hâline getiriyordu.
 *
 * Artık cilt tipinden BAĞIMSIZ ikinci bir eksen: birden fazla soruda dağılmış
 * sinyaller 0–7 arası bir puan üretiyor ve üç banda ayrılıyor:
 *   0–1  yok
 *   2–3  eğilim
 *   4+   belirgin
 *
 * Eksen üç yerde sonucu değiştiriyor: (a) sonuç ekranında kendi bölümü var,
 * (b) öncelik adımında nazik ürün tercih ediliyor, (c) belirgin bantta asitli
 * adımlar için kademeli başlangıç uyarısı gösteriliyor.
 */
const SENSITIVITY_SIGNALS = [
  { q: 3, a: 0, w: 3 }, /* "Sık sık kızarır ve kaşınır" — en güçlü sinyal */
  { q: 3, a: 2, w: 1 }, /* "Bölgeye göre değişir" — kısmi tepki */
  { q: 0, a: 0, w: 1 }, /* "Gergin ve kuru, hemen nem ister" — zayıf bariyer */
  { q: 4, a: 0, w: 1 }, /* "Pul pul dökülme ve kuruluk" */
  { q: 7, a: 0, w: 1 }, /* Hedef: "Sivilce ve kızarıklık görünümü" */
];

const SENSITIVITY_COPY = {
  egilim: {
    label: 'Hassasiyet Eğilimi',
    short: 'Eğilim',
    text: 'Yanıtlarınız zaman zaman tepki veren bir cilt bariyerine işaret ediyor. Rutininizdeki asitli adımı (toner pad veya peeling) haftada birden başlatın, cildiniz rahat ettikçe sıklığı artırın.',
  },
  belirgin: {
    label: 'Belirgin Hassasiyet',
    short: 'Hassas',
    text: 'Yanıtlarınız belirgin bir hassasiyete işaret ediyor. Yeni ürünleri teker teker ekleyin, aralarında birkaç gün bırakın ve asitli adımları önce haftada bir deneyin. Her yeni ürünü kol içinde 24 saat test etmenizi öneririz.',
  },
};

/* 8. soru: cilt tipini değil, önceliği belirler. */
const CONCERN_QUESTION = 7;
const CONCERN_KEYS = ['akne', 'leke', 'gozenek', 'yaslanma'];

/* 9. soru: yaş aralığı — puanlamaya girmez, sonuçta özellik etiketi olarak görünür. */
const AGE_QUESTION = 8;
const AGE_LABELS = ['18–24 yaş', '25–34 yaş', '35–44 yaş', '45+ yaş'];

/*
 * Öncelik başına rutine eklenecek ek adım.
 * primary = varsayılan, gentle = hassasiyet ekseni "yok" değilse tercih edilen
 * daha nazik seçenek. Rutinde zaten varsa atlanır; ikisi de varsa ek adım
 * hiç eklenmez.
 */
const CONCERN_STEPS = {
  akne: {
    step: 'Öncelik',
    primary: 'akne-toner-pad',
    gentle: 'akne-sabunu',
    why: 'Sivilce görünümü olan bölgeler için ek adım.',
  },
  leke: {
    step: 'Öncelik',
    primary: 'leke-karsiti-ve-aydinlatici-sabun',
    gentle: 'leke-karsiti-ve-aydinlatici-sabun',
    why: 'Ton eşitsizliği ve leke görünümü için ek adım.',
  },
  gozenek: {
    step: 'Öncelik',
    primary: 'gozenek-karsiti-ve-temizleyici-toner-pad',
    gentle: 'gozenek-sikilastirici-arindirci-sabun',
    why: 'Gözenek görünümü için ek adım.',
  },
  yaslanma: {
    step: 'Öncelik',
    primary: 'yaslanma-karsiti-krem-pdrn',
    gentle: 'yogun-nemlendirici-kolajen-maske',
    why: 'Yaşlanma belirtilerinin görünümü için ek adım.',
  },
};

class CiltTipiTesti extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';

    /*
     * Varyant liquid'den geliyor (section.settings.variant): 'ritual' ya da
     * 'editorial'. Tanınmayan bir değer gelirse ritüele düşüyoruz.
     */
    this.variant = this.dataset.variant === 'editorial' ? 'editorial' : 'ritual';
    this.className = 'ctt ctt--' + this.variant;

    this.LOGO_KREM = this.dataset.logoKrem || '';
    this.LOGO_BORDO = this.dataset.logoBordo || '';

    /* Stil sayfası belgeye bir kez giriyor, her render'da değil. */
    if (!document.getElementById('ctt-styles')) {
      const tag = document.createElement('style');
      tag.id = 'ctt-styles';
      tag.textContent = STYLES;
      document.head.appendChild(tag);
    }

    const resultsEl = document.querySelector('[data-ctt-results]');
    const productsEl = document.querySelector('[data-ctt-products]');
    const imagesEl = document.querySelector('[data-ctt-images]');
    /* Kampanya görselleri: adresler liquid'de, tema başına değiştirilebilir. */
    this.IMAGES = imagesEl ? JSON.parse(imagesEl.textContent) : {};
    this.RESULTS = resultsEl ? JSON.parse(resultsEl.textContent) : {};
    const productList = productsEl ? JSON.parse(productsEl.textContent) : [];
    this.PRODUCTS_BY_HANDLE = {};
    productList.forEach((p) => {
      this.PRODUCTS_BY_HANDLE[p.handle] = p;
    });

    let resumed = false;

    /* 1) Paylaşılan bağlantı: ?ct=... varsa doğrudan o sonucu aç. */
    const fromUrl = this.readSharedResultFromUrl();
    if (fromUrl) {
      this.sharedResult = fromUrl;
      this.state = { screen: 'result', i: QUESTIONS.length - 1, answers: [] };
      resumed = true;
    }

    /* 2) Form gönderimi sonrası dönüş: sessionStorage'daki türetilmiş sonuç. */
    if (!resumed) {
      try {
        const saved = sessionStorage.getItem('ctt_resume');
        if (saved) {
          sessionStorage.removeItem('ctt_resume');
          const data = this.decodeSharedResult(saved);
          if (data) {
            this.sharedResult = data;
            this.state = { screen: 'result', i: QUESTIONS.length - 1, answers: [] };
            resumed = true;
          }
        }
      } catch (e) {
        /* sessionStorage okunamazsa normal akışa devam */
      }
    }

    if (!resumed) {
      this.state = { screen: 'intro', i: 0, answers: [] };
    }

    this.measureOffset();
    this._onResize = () => this.measureOffset();
    window.addEventListener('resize', this._onResize, { passive: true });
    window.addEventListener('orientationchange', this._onResize, { passive: true });

    this.render();
  }

  /* Tema düzenleyici bölümü yeniden kurabiliyor; dinleyiciyi arkada bırakma. */
  disconnectedCallback() {
    if (this._onResize) {
      window.removeEventListener('resize', this._onResize);
      window.removeEventListener('orientationchange', this._onResize);
      this._onResize = null;
    }
    clearTimeout(this._t);
  }

  setState(patch) {
    this.state = { ...this.state, ...patch };
    this.render();
  }

  /*
   * VÀLIEN (10.09): Hızlı/çift tıklamada testin ileri kaçmasına veya
   * sıfırlanmasına karşı koruma. Üç kat:
   *   - yalnızca 'quiz' ekranındayken cevap alınır,
   *   - iki cevap arasında en az 260 ms bulunur,
   *   - son sorudan sonra gelen tıklamalar yok sayılır.
   */
  guard(key, ms) {
    const now = Date.now();
    if (!this._guards) this._guards = {};
    if (this._guards[key] && now - this._guards[key] < ms) return false;
    this._guards[key] = now;
    return true;
  }

  pick(idx) {
    if (this.state.screen !== 'quiz') return;
    if (!this.guard('pick', 260)) return;

    const answers = this.state.answers.slice(0, this.state.i);
    answers.push(idx);
    if (this.state.i === QUESTIONS.length - 1) {
      this.setState({ answers, screen: 'loading' });
      clearTimeout(this._t);
      this._t = setTimeout(() => this.setState({ screen: 'contact' }), 1800);
    } else {
      this.setState({ answers, i: this.state.i + 1 });
    }
  }

  /**
   * Verilen soru indekslerine göre cilt tipi puanlarını toplar.
   * @param {number[]|null} indices - null ise puanlanabilir tüm sorular.
   */
  scoreSkin(indices) {
    const score = { kuru: 0, yagli: 0, karma: 0, normal: 0 };

    this.state.answers.forEach((answer, qi) => {
      if (indices && indices.indexOf(qi) === -1) return;
      const row = SCORING[qi];
      if (!row) return;
      const weights = row[answer];
      if (!weights) return;
      Object.keys(weights).forEach((key) => {
        if (score[key] === undefined) return;
        score[key] += weights[key];
      });
    });

    return score;
  }

  /**
   * Cevapların ANLAMINA göre cilt tipini belirler.
   *
   * VÀLIEN — Beraberlik çözümü (Kademe 3, 10.09)
   *
   * Önceki sürüm `best = 'karma'` ile başlayıp katı `>` kullanıyordu ve
   * yorumunda "eşitlikte karma kazanır" yazıyordu. Bu yalnızca KARMA
   * beraberliğin içindeyse doğruydu. Karma dışarıda kaldığında kazananı
   * SKIN_KEYS dizisindeki sıra belirliyordu ve 'kuru' dizinin ilk elemanıydı:
   * "kuru 4 / normal 4" beraberliği sistematik olarak KURU veriyordu.
   * Düzeltildiği sanılan hatanın yarısı ayaktaydı.
   *
   * Yeni çözüm üç kademeli ve hiçbir aşamada dizi sırasına bakmıyor:
   *   1) En yüksek puan.
   *   2) Beraberlikte yalnızca cilt yapısını DOĞRUDAN ölçen sorular
   *      (ağırlığı 2 olanlar) yeniden puanlanır.
   *   3) Hâlâ beraberse 'karma' — belirsiz sonuçta önerilen rutini en geniş
   *      kitlede güvenli olan tip.
   *
   * @returns {string}
   */
  computeResultKey() {
    if (this.sharedResult) return this.sharedResult.skin;
    const score = this.scoreSkin(null);
    const max = Math.max.apply(null, SKIN_KEYS.map((key) => score[key]));
    let tied = SKIN_KEYS.filter((key) => score[key] === max);
    if (tied.length === 1) return tied[0];

    const direct = this.scoreSkin(DIRECT_QUESTIONS);
    const directMax = Math.max.apply(null, tied.map((key) => direct[key]));
    tied = tied.filter((key) => direct[key] === directMax);
    if (tied.length === 1) return tied[0];

    return 'karma';
  }

  /** Hassasiyet ekseni: 0–7 arası ham puan. */
  sensitivityScore() {
    return SENSITIVITY_SIGNALS.reduce(
      (sum, s) => (this.state.answers[s.q] === s.a ? sum + s.w : sum),
      0
    );
  }

  /** Hassasiyet bandı: 'yok' | 'egilim' | 'belirgin'. */
  sensitivityLevel() {
    if (this.sharedResult) return this.sharedResult.sens;
    const score = this.sensitivityScore();
    if (score >= 4) return 'belirgin';
    if (score >= 2) return 'egilim';
    return 'yok';
  }

  /** Nazik ürün tercihi bu eksene bağlı. */
  isSensitive() {
    return this.sensitivityLevel() !== 'yok';
  }

  /** 8. sorudan gelen öncelik anahtarı. */
  concernKey() {
    if (this.sharedResult) return this.sharedResult.concern;
    const answer = this.state.answers[CONCERN_QUESTION];
    return CONCERN_KEYS[answer] || null;
  }

  /** 9. sorudan gelen yaş aralığı indeksi; yanıtlanmamışsa null. */
  ageIndex() {
    if (this.sharedResult) return this.sharedResult.age;
    const answer = this.state.answers[AGE_QUESTION];
    return AGE_LABELS[answer] !== undefined ? answer : null;
  }

  /**
   * Rutine eklenecek öncelik adımını döndürür; uygun bir ürün yoksa null.
   * @param {string[]} existingHandles - Rutinde zaten bulunan ürün handle'ları.
   */
  concernStep(existingHandles) {
    const key = this.concernKey();
    if (!key) return null;

    const config = CONCERN_STEPS[key];
    if (!config) return null;

    const order = this.isSensitive()
      ? [config.gentle, config.primary]
      : [config.primary, config.gentle];

    for (const handle of order) {
      if (!handle) continue;
      if (existingHandles.indexOf(handle) !== -1) continue;
      const product = this.PRODUCTS_BY_HANDLE[handle];
      if (!product) continue;
      if (product.available === false) continue;
      return { step: config.step, handle, why: config.why };
    }

    return null;
  }

  /**
   * Bölümün sayfa başlığı altında nereden başladığını ölçüp CSS'e yazar.
   * Yükleme ekranı yüksekliğini bundan hesaplıyor.
   */
  measureOffset() {
    try {
      const top = this.getBoundingClientRect().top + (window.scrollY || 0);
      this.style.setProperty('--ctt-offset', Math.max(0, Math.round(top)) + 'px');
    } catch (e) {
      /* ölçülemezse CSS 0px'e düşer, ekran biraz uzun olur ama bozulmaz */
    }
  }

  /**
   * Ekranın zeminine göre doğru logo varyantını verir.
   * Ritüel varyantında giriş ve yükleme ekranları bordo zeminli olduğu için
   * krem logo; diğer her yerde bordo logo.
   * @param {string} cls
   */
  logoTag(cls) {
    const koyuZemin = this.variant === 'ritual' && ['intro', 'loading'].indexOf(this.state.screen) !== -1;
    const src = koyuZemin ? this.LOGO_KREM : this.LOGO_BORDO;
    if (!src) return '';
    return `<img class="ctt-logo ${cls}" src="${this.esc(src)}" alt="VÀLIEN" width="560" height="125">`;
  }

  esc(str) {
    const div = document.createElement('div');
    div.textContent = str == null ? '' : String(str);
    return div.innerHTML;
  }

  /*
   * Form gönderimi sayfayı yeniden yüklüyor; dönüşte sonucu tekrar gösterebilmek
   * için saklıyoruz. Ham yanıtlar değil, yalnızca türetilmiş sonuç yazılır.
   */
  saveResumeState() {
    try {
      sessionStorage.setItem('ctt_resume', this.encodeSharedResult());
    } catch (e) {
      /* sessionStorage yazılamazsa form yine de gönderilir, sadece resume çalışmaz */
    }
  }

  /* ---- Paylaşılabilir sonuç bağlantısı ---------------------------------- */

  /**
   * Türetilmiş sonucu dört karakterlik bir belirtece çevirir.
   * Sıra: cilt tipi · hassasiyet bandı · öncelik · yaş aralığı.
   * Cevaplanmamış alanlar '-' ile yazılır.
   */
  encodeSharedResult() {
    const slot = (arr, val) => {
      const i = arr.indexOf(val);
      return i < 0 ? '-' : String(i);
    };
    return (
      slot(SKIN_KEYS, this.computeResultKey()) +
      slot(CTT_SENS_KEYS, this.sensitivityLevel()) +
      slot(CONCERN_KEYS, this.concernKey()) +
      (this.ageIndex() === null ? '-' : String(this.ageIndex()))
    );
  }

  /** Belirteci çözer; geçersizse null döner. */
  decodeSharedResult(raw) {
    if (!raw || raw.length !== 4) return null;
    const pick = (arr, ch) => {
      if (ch === '-') return null;
      const i = Number(ch);
      return Number.isInteger(i) && arr[i] !== undefined ? arr[i] : null;
    };
    const skin = pick(SKIN_KEYS, raw[0]);
    if (!skin) return null;
    const ageCh = raw[3];
    const age =
      ageCh === '-' || AGE_LABELS[Number(ageCh)] === undefined ? null : Number(ageCh);
    return {
      skin,
      sens: pick(CTT_SENS_KEYS, raw[1]) || 'yok',
      concern: pick(CONCERN_KEYS, raw[2]),
      age,
    };
  }

  readSharedResultFromUrl() {
    try {
      return this.decodeSharedResult(
        new URLSearchParams(window.location.search).get(CTT_URL_PARAM)
      );
    } catch (e) {
      return null;
    }
  }

  resultUrl() {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set(CTT_URL_PARAM, this.encodeSharedResult());
      url.hash = '';
      return url.toString();
    } catch (e) {
      return window.location.href;
    }
  }

  syncUrl() {
    try {
      window.history.replaceState({}, '', this.resultUrl());
    } catch (e) {
      /* history yazılamazsa sonuç yine görünür, sadece bağlantı güncellenmez */
    }
  }

  clearUrl() {
    try {
      const url = new URL(window.location.href);
      if (!url.searchParams.has(CTT_URL_PARAM)) return;
      url.searchParams.delete(CTT_URL_PARAM);
      window.history.replaceState({}, '', url.toString());
    } catch (e) {
      /* yok sayılır */
    }
  }

  render() {
    const { screen, i, answers } = this.state;

    if (screen === 'intro') {
      this.innerHTML = this.renderIntro();
    } else if (screen === 'quiz') {
      this.innerHTML = this.renderQuiz(i, answers);
    } else if (screen === 'loading') {
      this.innerHTML = this.renderLoading();
    } else if (screen === 'contact') {
      this.innerHTML = this.renderContact();
    } else if (screen === 'result') {
      this.innerHTML = this.renderResult();
    }

    this.bindEvents();

    if (screen === 'loading') {
      /* Tam ekran anı: başlık görünür kalsın, bölüm kalan alanı tam doldursun. */
      try { window.scrollTo(0, 0); } catch (e) { /* yok sayılır */ }
      this.measureOffset();
    }

    if (screen === 'result') {
      this.syncUrl();
    } else {
      this.clearUrl();
    }

    if (screen === 'result' && !this._cttDiscountApplied) {
      this._cttDiscountApplied = true;
      cttApplyDiscountToCart(CTT_COUPON_CODE);
    }
  }


  bindEvents() {
    const startBtn = this.querySelector('[data-ctt-start]');
    if (startBtn) {
      startBtn.addEventListener('click', () => {
        if (!this.guard('nav', 400)) return;
        this.sharedResult = null;
        this.setState({ screen: 'quiz', i: 0, answers: [] });
      });
    }

    this.querySelectorAll('[data-ctt-pick]').forEach((btn) => {
      btn.addEventListener('click', () => this.pick(Number(btn.dataset.cttPick)));
    });

    const backBtn = this.querySelector('[data-ctt-back]');
    if (backBtn) {
      backBtn.addEventListener('click', () => {
        if (!this.guard('nav', 260)) return;
        if (this.state.i > 0) {
          this.setState({ i: this.state.i - 1 });
        } else {
          this.setState({ screen: 'intro' });
        }
      });
    }

    const restartBtn = this.querySelector('[data-ctt-restart]');
    if (restartBtn) {
      restartBtn.addEventListener('click', () => {
        if (!this.guard('nav', 400)) return;
        this.sharedResult = null;
        this.setState({ screen: 'intro', i: 0, answers: [] });
      });
    }

    const formTarget = this.querySelector('[data-ctt-real-form-target]');
    if (formTarget) {
      const realWrap = document.getElementById('ctt-real-contact-wrap');
      const realForm = document.getElementById('ctt-real-contact-form');
      if (realWrap && realForm) {
        formTarget.appendChild(realWrap);
        realWrap.style.display = 'block';
        if (!realForm.dataset.cttBound) {
          realForm.dataset.cttBound = 'true';
          realForm.addEventListener('submit', () => {
            this.saveResumeState();
            /*
             * VÀLIEN (10.09): Alan boş açılıyor ama müşteri odağa girip
             * çıktıysa içinde yalnız '0' kalmış olabilir. Rakamları ayıklayıp
             * anlamsız değeri temizliyoruz. (Önceki sürümde regex çift
             * kaçışlıydı ve hiçbir zaman eşleşmiyordu.)
             */
            const phoneEl = document.getElementById('ctt-real-phone');
            if (phoneEl) {
              const digits = phoneEl.value.replace(/\D/g, '');
              if (digits === '' || digits === '0') phoneEl.value = '';
            }
            /* preventDefault yok — gerçek form gönderimi CAPTCHA doğrulaması için gerekli */
          });
        }
        const phoneInput = document.getElementById('ctt-real-phone');
        if (phoneInput && !phoneInput.dataset.cttFormatBound) {
          phoneInput.dataset.cttFormatBound = 'true';
          const formatPhone = () => {
            let digits = phoneInput.value.replace(/\D/g, '');
            if (digits === '') {
              phoneInput.value = '';
              return;
            }
            if (!digits.startsWith('0')) digits = '0' + digits;
            digits = digits.slice(0, 11);
            const rest = digits.slice(1);
            const parts = [rest.slice(0, 3), rest.slice(3, 6), rest.slice(6, 8), rest.slice(8, 10)].filter(Boolean);
            phoneInput.value = '0' + (parts.length ? ' ' + parts.join(' ') : '');
          };
          phoneInput.addEventListener('input', formatPhone);
          phoneInput.addEventListener('blur', () => {
            if (phoneInput.value.replace(/\D/g, '') === '0') phoneInput.value = '';
          });
        }
      }
    }
    this.querySelectorAll('[data-ctt-add-to-cart]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const variantId = btn.dataset.cttAddToCart;
        const label = btn.querySelector('[data-ctt-cart-label]');
        if (btn.disabled) return;
        btn.disabled = true;
        btn.classList.add('is-loading');
        if (label) label.textContent = 'EKLENİYOR...';
        try {
          await cttAddLines([{ id: variantId, quantity: 1 }], 'cilt-tipi-testi');
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          if (label) label.textContent = 'EKLENDİ ✓';
        } catch (e) {
          btn.classList.remove('is-loading');
          if (label) label.textContent = 'TEKRAR DENE';
        }
        setTimeout(() => {
          btn.disabled = false;
          btn.classList.remove('is-done');
          if (label) label.textContent = 'EKLE';
        }, 2000);
      });
    });

    const cue = this.querySelector('[data-ctt-scrollcue]');
    if (cue) {
      cue.addEventListener('click', () => {
        const target = this.querySelector('.ctt-routine') || this.querySelector('.ctt-head');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      const hide = () => {
        if (window.scrollY > 120) {
          cue.classList.add('is-gone');
          window.removeEventListener('scroll', hide);
        }
      };
      window.addEventListener('scroll', hide, { passive: true });
    }

    this.querySelectorAll('[data-ctt-tab]').forEach((btn) => {
      btn.addEventListener('click', () => {
        this.routineTab = btn.dataset.cttTab === 'aksam' ? 'aksam' : 'sabah';
        this.render();
      });
    });

    const bundleBtn = this.querySelector('[data-ctt-add-bundle]');
    if (bundleBtn) {
      bundleBtn.addEventListener('click', async () => {
        if (bundleBtn.disabled) return;
        const ids = (bundleBtn.dataset.cttAddBundle || '').split(',').filter(Boolean);
        if (!ids.length) return;
        const label = bundleBtn.querySelector('[data-ctt-bundle-label]');
        bundleBtn.disabled = true;
        bundleBtn.classList.add('is-loading');
        if (label) label.textContent = 'EKLENİYOR...';
        try {
          await cttAddLines(ids.map((id) => ({ id, quantity: 1 })), 'cilt-tipi-testi-bundle');
          bundleBtn.classList.remove('is-loading');
          bundleBtn.classList.add('is-done');
          if (label) label.textContent = 'RUTİN SEPETE EKLENDİ ✓';
        } catch (e) {
          bundleBtn.classList.remove('is-loading');
          if (label) label.textContent = 'HATA, TEKRAR DENE';
        }
        setTimeout(() => {
          bundleBtn.disabled = false;
          bundleBtn.classList.remove('is-done');
          if (label) label.textContent = 'RUTİNİN TAMAMINI SEPETE EKLE';
        }, 2400);
      });
    }

    const contactSkip = this.querySelector('[data-ctt-contact-skip]');
    if (contactSkip) {
      contactSkip.addEventListener('click', () => {
        if (!this.guard('nav', 400)) return;
        this.setState({ screen: 'result' });
      });
    }

    /*
     * VÀLIEN (10.09): Sonucu paylaş / bağlantıyı kopyala.
     * Web Share API varsa (mobil) yerel paylaşım sayfası açılır; yoksa
     * bağlantı panoya kopyalanır. İki yolda da URL ?ct=... taşıdığı için
     * bağlantıyı açan kişi aynı sonucu görür.
     */
    const shareBtn = this.querySelector('[data-ctt-share]');
    if (shareBtn) {
      shareBtn.addEventListener('click', async () => {
        const label = shareBtn.querySelector('[data-ctt-share-label]');
        const url = this.resultUrl();
        const done = (text) => {
          if (!label) return;
          label.textContent = text;
          setTimeout(() => {
            label.textContent = 'SONUCU PAYLAŞ';
          }, 1800);
        };
        if (navigator.share) {
          try {
            await navigator.share({ title: 'Valien — Cilt Tipi Analizi Sonucum', url });
            return;
          } catch (e) {
            /* kullanıcı vazgeçtiyse veya paylaşım başarısızsa kopyalamaya düş */
          }
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          try {
            await navigator.clipboard.writeText(url);
            done('BAĞLANTI KOPYALANDI ✓');
            return;
          } catch (e) {
            /* pano yazılamadıysa aşağıya düş */
          }
        }
        done('BAĞLANTIYI KOPYALAYIN');
      });
    }

    const copyBtn = this.querySelector('[data-ctt-copy-coupon]');
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        const text = copyBtn.dataset.cttCopyCoupon || CTT_COUPON_CODE;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).catch(() => {});
        }
        cttApplyDiscountToCart(CTT_COUPON_CODE);
        const label = copyBtn.querySelector('[data-ctt-copy-label]');
        if (label) {
          const original = label.textContent;
          label.textContent = 'KOPYALANDI ✓';
          setTimeout(() => {
            label.textContent = original;
          }, 1800);
        }
      });
    }
  }

  /* ---- Ekranlar ---------------------------------------------------------- */

  renderIntro() {
    return `
      <section class="ctt-screen ctt-screen--intro">
        <div class="ctt-intro">
          <header class="a-head">
            ${this.logoTag('a-logo')}
            <div class="ctt-eyebrow a-eyebrow"><i class="ctt-tick"></i><span>CİLT ANALİZİ</span></div>
          </header>
          <h1 class="ctt-display a-title">Cildinizin Rönesansı<br>Burada Başlıyor</h1>
          <p class="ctt-lede a-lede">Dokuz sorudan oluşan kısa bir yolculuk. Cilt tipinizi ve hassasiyet eğiliminizi ayrı ayrı ölçüyor, size özel Japon formülasyonlu rutininizi öneriyoruz.</p>
          <ul class="ctt-spec a-spec">
            <li class="ctt-spec__row"><span class="ctt-spec__label">Soru</span><span class="ctt-spec__value">IX</span></li>
            <li class="ctt-spec__row"><span class="ctt-spec__label">Süre</span><span class="ctt-spec__value">75 sn</span></li>
            <li class="ctt-spec__row"><span class="ctt-spec__label">Ölçülen eksen</span><span class="ctt-spec__value">II</span></li>
          </ul>
          <div class="a-cta"><button class="ctt-btn" type="button" data-ctt-start>TESTE BAŞLA</button></div>
          <p class="ctt-fine a-fine">Bu test tıbbi bir teşhis aracı değildir ve hekim muayenesinin yerini tutmaz. Yalnızca bakım rutini önerisi sunar.</p>
        </div>
      </section>`;
  }

  renderQuiz(i, answers) {
    const q = QUESTIONS[i];
    const letters = ['A', 'B', 'C', 'D'];
    const progress = Math.round(((i + 1) / QUESTIONS.length) * 100);
    const remaining = QUESTIONS.length - i - 1;

    const options = q.a
      .map((text, n) => `
        <button class="ctt-option${answers[i] === n ? ' is-on' : ''}" type="button" data-ctt-pick="${n}">
          <span class="ctt-option__key">${letters[n]}</span>
          <span class="ctt-option__text">${this.esc(text)}</span>
        </button>`)
      .join('');

    return `
      <section class="ctt-screen ctt-screen--quiz">
        <div class="ctt-quiz">
          <div class="ctt-quiz__rail">
            <header class="ctt-quiz__head">
              <span class="ctt-quiz__num">${ROMAN[i]}</span>
              <span class="ctt-quiz__cat">${this.esc(q.cat.toLocaleUpperCase('tr-TR'))}</span>
              <span class="ctt-quiz__count">${i + 1} / ${QUESTIONS.length}</span>
            </header>
            <div class="ctt-progress"><i style="width:${progress}%"></i></div>
          </div>
          <h2 class="ctt-display ctt-display--m">${this.esc(q.q)}</h2>
          <div class="ctt-options">${options}</div>
          <footer class="ctt-quiz__foot">
            <button class="ctt-link" type="button" data-ctt-back>← GERİ</button>
            <span>${remaining} SORU KALDI</span>
          </footer>
        </div>
      </section>`;
  }

  /*
   * VÀLIEN (10.09): Yükleme ekranı artık kampanya görselinin kendisi.
   * Alt kenarda krem kelime işareti, ilerleme cetveli ve tek satır; görselin
   * kendi metniyle çakışmasın diye küçük ve altta.
   * Geniş ekranda yatay hero, dar ekranda dikey görsel.
   */
  renderLoading() {
    const genis = this.IMAGES.heroGenis;
    const dar = this.IMAGES.heroDar || genis;
    /*
     * Görsel yoksa kelime işaretine düşüyoruz. Bu yedek, .ctt-loading'in
     * İÇİNDE durmak zorunda: .ctt-screen bir satır flex'i, dışarıda kalırsa
     * logo ile cetvel yan yana dizilip kayık görünüyor.
     */
    const gorsel = genis
      ? `<picture class="ctt-loading__gorsel">
          <source media="(min-width: 900px)" srcset="${this.esc(genis)}">
          <img src="${this.esc(dar)}" alt="Valien — Cilt Bakımında Rönesans" fetchpriority="high">
        </picture>`
      : '';

    return `
      <section class="ctt-screen ctt-screen--loading${genis ? ' has-gorsel' : ''}">
        ${gorsel}
        <div class="ctt-loading">
          ${genis
            ? `<img class="ctt-logo ctt-loading__logo" src="${this.esc(this.LOGO_KREM)}" alt="VÀLIEN" width="560" height="125">`
            : this.logoTag('ctt-loading__logo')}
          <div class="ctt-draw"><i></i></div>
          <p class="ctt-loading__text">Yanıtlarınız okunuyor</p>
        </div>
      </section>`;
  }

  renderContact() {
    return `
      <section class="ctt-screen ctt-screen--contact">
        <div class="ctt-card">
          <div class="ctt-eyebrow"><i class="ctt-tick"></i><span>SON ADIM · İSTEĞE BAĞLI</span></div>
          <h2 class="ctt-display ctt-display--m">₺125 İndirim Kodunuz Hazır</h2>
          <p class="ctt-lede">Sonucunuzu görmeden önce, dilerseniz e-posta veya telefon numaranızı bırakın — kupon kodunuzu size de iletelim. Bu adım tamamen isteğe bağlıdır.</p>
          <div class="ctt-formslot" data-ctt-real-form-target></div>
          <button class="ctt-link ctt-link--center" type="button" data-ctt-contact-skip>ATLA, SADECE SONUCU GÖR</button>
        </div>
      </section>`;
  }

  renderStep(item, index) {
    const p = this.PRODUCTS_BY_HANDLE[item.handle];
    if (!p) return '';
    return `
      <li class="ctt-step">
        <span class="ctt-step__no">${index + 1}</span>
        <div class="ctt-step__body">
          <span class="ctt-step__label">${this.esc(item.step)}</span>
          <a class="ctt-step__link" href="${this.esc(p.url)}">
            ${p.image ? `<img class="ctt-step__img" src="${this.esc(p.image)}" alt="${this.esc(p.name)}" width="72" height="72" loading="lazy">` : ''}
            <span class="ctt-step__meta">
              <span class="ctt-step__name">${this.esc(p.name)}</span>
              <span class="ctt-step__price">${this.esc(p.price)}</span>
            </span>
          </a>
          ${item.why ? `<p class="ctt-step__why">${this.esc(item.why)}</p>` : ''}
        </div>
        ${p.variantId && p.available !== false
          ? `<button class="ctt-add" type="button" data-ctt-add-to-cart="${this.esc(p.variantId)}"><span data-ctt-cart-label>EKLE</span></button>`
          : ''}
      </li>`;
  }

  renderResult() {
    const key = this.computeResultKey();
    const r = this.RESULTS[key] || {};
    const tab = this.routineTab === 'aksam' ? 'aksam' : 'sabah';

    const sensLevel = this.sensitivityLevel();
    const sens = SENSITIVITY_COPY[sensLevel] || null;
    const ageIdx = this.ageIndex();

    const baseHandles = [].concat(r.sabah || [], r.aksam || [], r.haftalik || []).map((x) => x.handle);
    const extra = this.concernStep(baseHandles);

    const sabahList = (r.sabah || []).concat(extra ? [extra] : []);
    const aksamList = (r.aksam || []).concat(extra ? [extra] : []);
    const activeList = tab === 'aksam' ? aksamList : sabahList;

    const steps = activeList.map((it, i) => this.renderStep(it, i)).join('');
    const weekly = (r.haftalik || []).map((it, i) => this.renderStep(it, i)).join('');

    const traitLabels = (r.traits || []).slice();
    if (ageIdx !== null) traitLabels.push(AGE_LABELS[ageIdx]);
    const traits = traitLabels.map((l) => `<span class="ctt-trait">${this.esc(l)}</span>`).join('');

    const bundle = [...new Set([].concat(sabahList, aksamList).map((x) => x.handle))]
      .map((h) => this.PRODUCTS_BY_HANDLE[h])
      .filter((p) => p && p.variantId && p.available !== false)
      .map((p) => p.variantId);

    /*
     * Cilt tipine özel kampanya görseli. Görseller kendi metinlerini taşıdığı
     * için kırpmıyoruz: doğal oranında, tam genişlikte gösteriliyor.
     */
    const gorselSrc = this.IMAGES[key];
    /*
     * Cilt tipi sonucu görselin üzerinde, tam ortada: ince etiket, büyük
     * değer, ince hassasiyet satırı. Fotoğrafın ortası açık tenli olduğu için
     * altına yumuşak koyu bir tül var, yoksa krem yazı okunmuyor.
     */
    const verdict = `
      <div class="ctt-verdict">
        <span class="ctt-verdict__label">CİLT TİPİNİZ</span>
        <span class="ctt-verdict__value">${this.esc(r.short)}</span>
        ${sens ? `<span class="ctt-verdict__sub">${this.esc(sens.short)}</span>` : ''}
      </div>`;
    const gorsel = gorselSrc
      ? `<figure class="ctt-gorsel"><img src="${this.esc(gorselSrc)}" alt="Valien" loading="lazy">${verdict}</figure>`
      : `<div class="ctt-gorsel ctt-gorsel--bos">${verdict}</div>`;

    /* İki eksen tek bir okumada: cilt tipi solda, hassasiyet sağda. */
    const axis = `
      <section class="ctt-axes">
        <div class="ctt-axis">
          <span class="ctt-axis__label">BİRİNCİ EKSEN · CİLT TİPİ</span>
          <span class="ctt-axis__value">${this.esc(r.title)}</span>
          <div class="ctt-scale">${SKIN_KEYS.map((k) => `<i class="${k === key ? 'is-on' : ''}"></i>`).join('')}</div>
        </div>
        <div class="ctt-axis">
          <span class="ctt-axis__label">İKİNCİ EKSEN · HASSASİYET</span>
          <span class="ctt-axis__value">${sens ? this.esc(sens.label) : 'Belirgin sinyal yok'}</span>
          <div class="ctt-scale ctt-scale--3">${['yok', 'egilim', 'belirgin'].map((b) => `<i class="${b === sensLevel ? 'is-on' : ''}"></i>`).join('')}</div>
        </div>
      </section>`;

    /*
     * VÀLIEN (10.09): Sonucun başındaki iki paragraf kaldırıldı.
     *   - "Belirgin sinyal yok" metni hiçbir şey söylemiyordu; eksen çubuğu
     *     zaten aynı bilgiyi veriyor.
     *   - Yaş notu genel bir tavsiyeydi, kişiselleştirme değeri taşımıyordu;
     *     yaş bandı özellik etiketi olarak duruyor.
     * Gerçek hassasiyet yönergesi silinmedi, rutinin başına taşındı — orada
     * uygulanabilir bir talimat: "asitli adımı haftada birden başlat".
     */
    const sensAdvice = sens
      ? `<div class="ctt-advice">
          <span class="ctt-advice__label">NASIL BAŞLAMALI</span>
          <p>${this.esc(sens.text)}</p>
        </div>`
      : '';

    return `
      <section class="ctt-screen ctt-screen--result">
        <div class="ctt-result">

          <div class="ctt-col-side">
            <div class="ctt-coupon">
              <span class="ctt-coupon__label">TESTİ TAMAMLAYANLARA ÖZEL</span>
              <div class="ctt-coupon__row">
                <span class="ctt-coupon__code">${CTT_COUPON_CODE}</span>
                <button class="ctt-copy" type="button" data-ctt-copy-coupon="${CTT_COUPON_CODE}"><span data-ctt-copy-label>KOPYALA</span></button>
              </div>
              <span class="ctt-coupon__note">Kodunuz sepetinize otomatik uygulandı — ödemede ₺125 indirim.</span>
            </div>
            <button class="ctt-btn ctt-btn--ghost" type="button" data-ctt-share><span data-ctt-share-label>SONUCU PAYLAŞ</span></button>
            <p class="ctt-fine">Bu sayfanın bağlantısını kaydedin — sonucunuz bağlantının içinde saklanır.</p>
            <button class="ctt-link ctt-restart" type="button" data-ctt-restart>TESTİ YENİDEN YAP</button>
          </div>

          <div class="ctt-col-main">
            <header class="ctt-result__head">
              <div class="ctt-eyebrow"><i class="ctt-tick"></i><span>SONUCUNUZ</span></div>
              <h2 class="ctt-display">${this.esc(r.title)}</h2>
              <p class="ctt-lede">${this.esc(r.text)}</p>
              <div class="ctt-traits">${traits}</div>
            </header>

            ${gorsel}
            ${axis}
            ${sensAdvice}

            <div class="ctt-routine">
              <div class="ctt-tabs" role="tablist">
                <button class="ctt-tab${tab === 'sabah' ? ' is-on' : ''}" type="button" role="tab" aria-selected="${tab === 'sabah'}" data-ctt-tab="sabah">Sabah</button>
                <button class="ctt-tab${tab === 'aksam' ? ' is-on' : ''}" type="button" role="tab" aria-selected="${tab === 'aksam'}" data-ctt-tab="aksam">Akşam</button>
              </div>
              <ol class="ctt-steps">${steps}</ol>
              ${weekly ? `<div class="ctt-weekly"><span class="ctt-weekly__title">HAFTALIK BAKIM</span><ol class="ctt-steps">${weekly}</ol></div>` : ''}
              ${bundle.length ? `<button class="ctt-btn ctt-btn--wide" type="button" data-ctt-add-bundle="${bundle.join(',')}"><span data-ctt-bundle-label>RUTİNİN TAMAMINI SEPETE EKLE</span></button>` : ''}
              <p class="ctt-fine">Bu öneri tıbbi tavsiye değildir. Cildinizde kalıcı tahriş, yara veya alerjik reaksiyon varsa bir sağlık kuruluşuna başvurun.</p>
            </div>
          </div>

        </div>
      </section>`;
  }
}

if (!customElements.get('cilt-tipi-testi')) {
  customElements.define('cilt-tipi-testi', CiltTipiTesti);
}
